









































































import { Component, Mixins } from "vue-property-decorator";
import GameMixin, { GameInterface } from "@/components/GameMixins.vue";
import ItemSelection, { item } from "@/components/shared/ItemSelection.vue";
import Undo from "@/components/shared/Undo.vue";
import Difficulty from "@/components/shared/Difficulty.vue";
import {
  edge,
  graph,
  alphabet,
  checkValidity,
  checkSimpleMushRoundtrip,
  getMushCount,
} from "@/components/paths/Graph";


@Component<Collect>({
  components: {
    ItemSelection,
    Undo,
    Difficulty,
  },
})
export default class Collect extends Mixins(GameMixin) implements GameInterface {
  g: graph = {nVertices:0, nEdges:0, edges:[]};
  origin: number = null;
  mushrooms: number[] = null;
  oVertex: string;
  currentDifficultyLevel = 1;
  noMush: number = null;
  mushLimit: number = null;
  nE = this.edgeNumber(this.currentDifficultyLevel);
  difficultyLevels = 3;

  edgeNumber(currentDifficultyLevel): number {
    switch (currentDifficultyLevel) {
      case 1: {
        return 12;
      }
      case 2: {
        return 20;
      }
      case 3: {
        return 28;
      }
      default: {
        return 12;
      }
    }
  }

  mushrooms1 = [0, 1, 2, 4, 3, 3, 5, 1];
  mushrooms2 = [3, 0, 1, 4, 3, 4, 2, 3, 1, 3, 1, 5];
  mushrooms3 = [3, 0, 1, 4, 3, 4, 2, 3, 1, 3, 0, 0, 5, 1, 2, 1];

  matrix1 = [[0, 1], [0, 4], [1, 2], [1, 3], [2, 3], [2, 5], [3, 4], [3, 5], [3, 6], [4, 7], [5, 6], [6, 7]];
  matrix2 = [[0, 1], [0, 2], [0, 3], [1, 2], [1, 4], [2, 5], [2, 6], [3, 6], [3, 7], [4, 5], [4, 8], [5, 8], [5, 9], [6, 7], [6, 9], [7, 10], [8, 11], [9, 10], [9, 11], [10, 11]];
  matrix3 = [[0, 1], [0, 2], [0, 3], [1, 2], [1, 4], [2, 3], [2, 5], [3, 6], [3, 7], [4, 5], [4, 8], [5, 6], [5, 8], [5, 9], [6, 7], [7, 9], [7, 10], [8, 11], [8, 12], [9, 12], [9, 13], [10, 13], [10, 14], [10, 15], [11, 13], [11, 14], [11, 15], [13, 14]];

   off() {
    document.getElementById("overlay0").style.display = "none";
    document.getElementById("overlay1").style.display = "none";
    document.getElementById("overlay2").style.display = "none";
    document.getElementById("overlay4").style.display = "none";
    document.getElementById("overlay5").style.display = "none";
    document.getElementById("overlay7").style.display = "none";
    document.getElementById("overlay9").style.display = "none";
    document.getElementById("overlay11").style.display = "none";
  }

  on(id: number) {
    document.getElementById(`overlay${id}`).style.display = "block";
    setTimeout(() => {
        this.off();
    }, 3500);
  }

  toggleColor(id: number){
      const index = id - 1;
      const list = document.getElementById(id.toString()).classList;
      if (list[4] == 'sel'){
        document.getElementById(id.toString()).classList.remove('sel');
        document.getElementById(`l_${this.currentDifficultyLevel}_${id}`).style.color = "black"
        this.g.edges[index].selected=false;
      } else {
        document.getElementById(id.toString()).classList.add('sel');
        document.getElementById(`l_${this.currentDifficultyLevel}_${id}`).style.color = "red"
        this.g.edges[index].selected=true;
      }
  }

  changeDifficultyLevel(newLevel: number) {
    this.currentDifficultyLevel = newLevel;
    this.nE = this.edgeNumber(this.currentDifficultyLevel);
    this.start(); 
  }

  removeSelection(){
    for (let i = 1; i <= this.nE; i++) {
      try {
        document.getElementById(i.toString()).classList.remove('sel');
        document.getElementById(`l_${this.currentDifficultyLevel}_${i}`).style.color = "black"
        this.g.edges[i-1].selected=false;
      } catch {
          console.log("not removed")
      }
    }
  }

  isInitialized(): boolean {
    return this.origin !== null;
  }

  start(){
    if(this.nE){
      this.removeSelection();
    }
    let matrix = null;
    switch (this.currentDifficultyLevel) {
      case 1: {
        this.g.nVertices=8;
        this.g.nEdges=12;
        this.g.edges;
        matrix = this.matrix1;
        this.mushrooms = this.mushrooms1;
        this.mushLimit = 14;
        break;
      }
      case 2: {
        this.g.nVertices=12;
        this.g.nEdges=20;
        this.g.edges;
        matrix = this.matrix2;
        this.mushrooms = this.mushrooms2;
        this.mushLimit = 20;
        break;
      }
      case 3: {
        this.g.nVertices=16;
        this.g.nEdges=28;
        this.g.edges;
        matrix = this.matrix3;
        this.mushrooms = this.mushrooms3;
        this.mushLimit = 22;
        break;
      }
      default: {
        matrix = this.matrix1;
        break;
      }
    }
    this.g.edges = [];
    for (let i = 1; i <= this.g.nEdges; i++) {
      const e: edge = {id:i, v1:matrix[i-1][0], v2:matrix[i-1][1], weight:0, selected:false};
      this.g.edges.push(e)
    }
    
    this.origin = Math.floor(this.randomNumber(this.g.nVertices));
    this.noMush = Math.floor(this.randomNumber(this.mushLimit));

    this.removeSelection;
    this.oVertex = alphabet[this.origin];

    
  
  }


  // returns the id numbers of the selected edges
  getSelected(): number[]{
    const sel: number[] = [];
      for (let i = 0; i < this.g.nEdges; i++){
          const index = i + 1;
          const list = document.getElementById(index.toString()).classList;
          if (list[4] == 'sel'){
            sel.push(i);
          }
      }
    return sel
  }

  undo(){
    this.removeSelection();
  }
  
  isCorrect() {
    
    let x = checkValidity(this.g, this.getSelected(), this.origin, this.origin);
    let check = (x == 3 || x == 4);
    if(x == 6 || x == 8){
      x = 9;
    }
    if (!check) {
      this.on(x);
    } else {this.off();}

    const sol: boolean[] = [];

    const res = checkSimpleMushRoundtrip(this.g, this.getSelected(), this.origin);
    const count = getMushCount(this.g, this.getSelected(), this.mushrooms);
    const res2 = (count >= this.noMush);
    if(check && !res2){
      check = false;
      this.on(11);
    }

    const first = res && res2;
    sol.push(first);
    sol.push(check);
  
    return sol;
  }
  
  
}


